import React from "react";
import UserConfirmForm from "forms/UserConfirmForm";
import PropTypes from "prop-types";
import { currentUserShape } from "shapes";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import Translate from "utils/translate";

import UserConfirmAgreement from "./UserConfirmAgreement";

const { t } = new Translate("UserConfirmModal");

export default class UserConfirmModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isConfirmed: false };

    this.handleConfirm = this.handleConfirm.bind(this);
  }

  handleConfirm() {
    this.setState({ isConfirmed: true });
  }

  render() {
    const { isConfirmed } = this.state;
    const { currentUser, isSubmitting, onCancel, onConfirm } = this.props;

    if (!isConfirmed) {
      return (
        <UserConfirmAgreement
          currentUser={currentUser}
          onAgree={this.handleConfirm}
          onCancel={onCancel}
          isOpen
        />
      );
    }

    return (
      <Modal isOpen>
        <ModalHeader isCloseable={false}>{t("details.title")}</ModalHeader>
        <ModalBody isInfo>{t("details.description")}</ModalBody>
        <ModalBody>
          <UserConfirmForm
            isBroker={currentUser.company.role === "broker"}
            isSubmitting={isSubmitting}
            onCancel={onCancel}
            onSubmit={onConfirm}
            user={currentUser}
          />
        </ModalBody>
      </Modal>
    );
  }
}

UserConfirmModal.propTypes = {
  currentUser: PropTypes.shape(currentUserShape),
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
